{
  "pt": {
    "issue_list": {
      "actions": {
        "add_units": "Unidades",
        "change_responsible": "Alterar responsável",
        "check": "Verificar",
        "create_issue_lists": "Criar lista de defeitos | Criar listas de defeitos",
        "delete": "Eliminar",
        "delete_count": "Está prestes a eliminar os defeitos de {count} unidade. Tem a certeza? | Está prestes a eliminar os defeitos de {count} unidades. Tem a certeza?",
        "delete_issue_lists": "Eliminar defeitos",
        "edit": "Editar",
        "edit_issue_list": "Editar o tipo de lista de defeitos",
        "export": "Exportar",
        "generatePDF": "Gerar PDF",
        "go_to_summary": "Ir para o resumo",
        "new": "Defeito",
        "new_customer": "Comunicar defeito",
        "new_issue_list": "Lista de defeitos",
        "selectAll": "Selecionar todas as {total} listas",
        "unSelectAll": "Limpar seleção",
        "update": "Atualizar"
      },
      "attributes": {
        "date": "Data de início",
        "description": "Descrição",
        "name": "Nome"
      },
      "labels": {
        "aftercare_conversations": "Conversas de pós-venda",
        "aftercare_conversations_go_to_settings": "Ir para definições",
        "aftercare_conversations_not_enabled": "As conversas de pós-venda ainda não estão ativadas. Pode ativá-las nas definições da sua organização.",
        "aftercare_conversations_toggle": "Permitir conversas de pós-venda",
        "assign_to_list": "Atribuir à lista",
        "completed_header": "{completed_count} de {issues_count} defeitos concluídos",
        "customer": "Cliente",
        "date": "Data de início (facultativo)",
        "delete_explanation": "Todos os defeitos, juntamente com as suas imagens e documentos, serão removidos permanentemente da plataforma.",
        "description_title": "Adicionar uma descrição",
        "deselect_all": "Desmarcar tudo",
        "edit_multiple": "Editar {count} listas de defeitos",
        "hide_count": "Anular a publicação de defeitos para 1 unidade | Anular a publicação de defeitos para {count} unidades",
        "hide_count_SUP": "Anular a publicação de defeitos",
        "issue_list": "Lista de defeitos",
        "issue_lists": "Pós-venda",
        "issue_lists_all_projects": "Pós-venda todos os projetos",
        "issues_count": "Defeitos",
        "no_issues_to_export": "Sem defeitos para exportar",
        "no_lists_completed": "Não foram preenchidas listas",
        "partners": "Parceiros",
        "pdf_generated_successfully": "PDF gerado com sucesso",
        "process_issues": "Atribuir à lista",
        "project_units_total": "{project_name} tem {units_count_max} unidades no total",
        "publish_now": "Publicar agora?",
        "published_count": "Publicar defeitos para 1 unidade | Publicar defeitos para {count} unidades",
        "published_count_SUP": "Publicar defeitos",
        "save_explainer": "Tornar os (futuros) defeitos visíveis para os seus clientes? Ou guardar e publicar mais tarde?",
        "selectOne": "Selecionar pelo menos 1 lista",
        "select_all": "Selecionar tudo",
        "selected": "{selected} lista selecionada. | {selected} listas selecionadas",
        "status": "estado",
        "step_1_info": "Por exemplo, entrega preliminar ou final, defeitos na cozinha ou nas casas de banho,...",
        "step_1_title": "Que tipo de lista de defeitos pretende elaborar?",
        "step_2_subtitle": "Selecione o seu projeto para incluir todas as suas unidades de uma só vez. Pode sempre adicionar mais unidades mais tarde.",
        "step_2_title": "Para que unidades pretende registar os defeitos?",
        "tab_issue_list_documents": "Documentos",
        "tab_issue_list_issues": "Defeitos",
        "tab_issue_list_issues_customer": "Pós-Venda",
        "tab_issue_list_tickets": "Conversas",
        "tab_issues": "Todos os Defeitos",
        "tab_units": "Unidades",
        "totalSelected": "Todas as {total} listas são selecionadas",
        "you_have_customer_issues": "Tem 1 defeito de cliente não processado | Tem {number} defeitos de cliente não processados"
      },
      "navigation": {
        "back_to_issue_lists": "De volta às listas de defeitos"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Acompanhamento dos defeitos comunicados",
            "title": "Todos os seus defeitos serão mostrados aqui"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Criar defeitos para as unidades anexadas à lista",
            "title": "Crie a sua primeira lista de defeitos"
          }
        },
        "partners": {
          "subtitle": "Será notificado quando forem criados novos defeitos",
          "title": "Ainda não lhe foram atribuídos defeitos"
        }
      },
      "validation": {
        "name_taken_locale": "Este nome já está em uso neste idioma",
        "need_name": "O nome é obrigatório"
      }
    }
  }
}
